import ShButton from '@/components/Helpers/ShButton';
import ShDividerLine from '@/components/Helpers/ShDividerLine';
import EmptyListOnStartup from '@/components/Common/EmptyListOnStartup';
import AddNewElementButton from '@/components/Common/AddNewElementButton';
import DepartmentsListItem from './DepartmentsListItem';

// @vue/component
export default {
  name: 'DepartmentsList',

  components: {
    ShButton,
    ShDividerLine,
    EmptyListOnStartup,
    AddNewElementButton,
    DepartmentsListItem,
  },

  props: {
    agentsList: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'agents/getList',
        'departments/getList',
        'departments/delete',
      ]);
    },
    departmentsList() {
      return this.$store.getters['departments/list'];
    },
    isEmpty() {
      return this.departmentsList.length === 0;
    },
  },

  created() {
    this.$store.dispatch('departments/getList');
  },

  methods: {
    handleCreateNewDepartment() {
      this.$EventBus.$emit('DepartmentsList/CREATE_NEW_DEPARTMENT');
    },
  },
};
